export const SvgIcons = {
  wealthCraftLogo: '/svgs/wci-logo.svg',
  addressIcon: {
    name: 'address',
    path: './svgs/',
  },
  callIcon: {
    name: 'call',
    path: './svgs/',
  },
  mailIcon: {
    name: 'mail',
    path: './svgs/',
  },
  timeIcon: {
    name: 'time',
    path: './svgs/',
  },
  mobileDev: {
    name: 'mobileAppDevelopement',
    path: './svgs/',
  },
  webDev: {
    name: 'webDevlopement',
    path: './svgs/',
  },
  digitalMarketing: {
    name: 'digitalMarketing',
    path: './svgs/',
  },
  UXUIDesigning: {
    name: 'UXUIDesigning',
    path: './svgs/',
  },
  productDesigning: {
    name: 'product&designing',
    path: './svgs/',
  },
  dataProcessing: {
    name: 'dataProcessing',
    path: './svgs/',
  },
  cloudDevOps: {
    name: 'cloud&devOps',
    path: './svgs/',
  },
  backendDev: {
    name: 'backendDevelopment',
    path: './svgs/',
  },
  freeSupport: {
    name: 'freeSupport',
    path: './svgs/',
  },
  quote: {
    name: 'quote',
    path: './svgs/',
  },
  projectCall: {
    name: 'sectionCall',
    path: './svgs/',
  },
  textFieldIcon: {
    name: 'textFieldIcon',
    path: './svgs/',
  },
  whatsApp: {
    name: 'whatsapp',
    path: './svgs/',
  },
  navLeft: {
    name: 'navLeftArrow',
    path: './svgs/',
  },
  navRight: {
    name: 'navRightArrow',
    path: './svgs/',
  },
};
